import Storage from '@/lib/Storage'
import { Typography, Box, Theme, useTheme } from '@mui/material'

type Props = {
  title: string
}

const styles = {
  header: {
    mb: 3,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: '#333'
  },
  titleSpanAndSeparator: (theme: Theme) => ({
    color: theme.palette.text.primary
  }),
  titleSpan2: (theme: Theme) => ({
    color: theme.palette.primary.main
  })
}

const Header = ({ title }: Props) => {
  const theme = useTheme()
  const { subname } = Storage().getActiveRole()

  return (
    <Box sx={styles.header}>
      <Typography variant="h5" component="h1" sx={styles.title}>
        <span style={styles.titleSpanAndSeparator(theme)}>{subname}</span>
        <span style={styles.titleSpanAndSeparator(theme)}>{' / '}</span>
        <span style={styles.titleSpan2(theme)}>{title}</span>
      </Typography>
    </Box>
  )
}

export default Header
